module.exports = __webpack_public_path__ + "static/media/citadel.109016e9.png";